(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["soa-customer-stories"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = root => root.querySelectorAll('[data-soa-reviews]').forEach(section => {
  if(section.dataset.ready) return;
  section.dataset.ready='true';
  const track=section.querySelector('[data-reviews-track]'),cards=[...section.querySelectorAll('[data-review-card]')];
  const prev=section.querySelector('[data-reviews-prev]'),next=section.querySelector('[data-reviews-next]'),status=section.querySelector('[data-reviews-status]'),nav=section.querySelector('.soa-reviews-nav'),toggle=section.querySelector('[data-reviews-motion]');
  if(!cards.length) return;
  for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]];}
  const fragment=document.createDocumentFragment();cards.forEach(card=>fragment.append(card));track.append(fragment);
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let paused=reduced.matches,hovered=false,visible=false;
  const motion=()=>reduced.matches?'instant':'smooth';
  const setPause=value=>{paused=value;toggle.textContent=paused?toggle.dataset.playLabel:toggle.dataset.pauseLabel;toggle.setAttribute('aria-pressed',String(paused));status.setAttribute('aria-live',paused?'polite':'off');};
  const update=()=>{const box=track.getBoundingClientRect();const shown=cards.map((card,i)=>({i,r:card.getBoundingClientRect()})).filter(({r})=>r.left>=box.left-4&&r.left<box.right-40);if(shown.length)status.textContent=`${shown[0].i+1}${shown.length>1?'–'+(shown[shown.length-1].i+1):''} / ${cards.length}`;prev.disabled=track.scrollLeft<3;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;};
  nav.hidden=false;toggle.hidden=false;setPause(paused);update();
  const advance=direction=>{const gap=parseFloat(getComputedStyle(track).columnGap)||20;const width=cards[0].getBoundingClientRect().width+gap;const step=Math.max(1,Math.floor((track.clientWidth+gap)/width));track.scrollBy({left:direction*width*step,behavior:motion()});};
  prev.addEventListener('click',()=>{setPause(true);advance(-1);});next.addEventListener('click',()=>{setPause(true);advance(1);});toggle.addEventListener('click',()=>setPause(!paused));
  track.addEventListener('pointerdown',()=>setPause(true));track.addEventListener('focusin',()=>setPause(true));
  section.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')hovered=true;});section.addEventListener('pointerleave',()=>hovered=false);
  let pending=false;track.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(()=>{pending=false;update();});}},{passive:true});
  const resize=new ResizeObserver(update);resize.observe(track);
  const observer=new IntersectionObserver(entries=>{visible=entries.some(e=>e.isIntersecting);},{threshold:.15});observer.observe(track);
  reduced.addEventListener('change',()=>{if(reduced.matches)setPause(true);});
  const timer=setInterval(()=>{if(!document.contains(section)){clearInterval(timer);observer.disconnect();resize.disconnect();return;}if(paused||hovered||!visible||document.hidden||reduced.matches)return;if(track.scrollLeft+track.clientWidth>=track.scrollWidth-3)track.scrollTo({left:0,behavior:motion()});else advance(1);},6500);
 });
 init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soa-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.soa-home-demo video').forEach((video) => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const media = video.closest('.soa-home-demo__media');
  const poster = document.createElement('img');
  poster.src = video.poster;
  poster.alt = '';
  poster.width = 1920;
  poster.height = 1080;
  poster.className = 'soa-home-demo__poster';
  poster.setAttribute('aria-hidden', 'true');
  media.appendChild(poster);
  video.controls = false;
  video.muted = true;
  video.defaultMuted = true;
  let inView = !('IntersectionObserver' in window);
  const sync = () => {
    if (reduced.matches || !inView || document.hidden) {
      media.classList.remove('is-playing');
      video.autoplay = false;
      video.pause();
      return;
    }
    video.autoplay = true;
    const playback = video.play();
    if (playback) playback.then(() => {
      if (!reduced.matches && !video.paused) media.classList.add('is-playing');
    }).catch(() => media.classList.remove('is-playing'));
  };
  video.addEventListener('playing', () => {
    if (!reduced.matches) media.classList.add('is-playing');
  });
  video.addEventListener('error', () => media.classList.remove('is-playing'));
  reduced.addEventListener('change', sync);
  document.addEventListener('visibilitychange', sync);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => { inView = entries.some(entry => entry.isIntersecting); sync(); }).observe(video);
  }
  sync();
});

  } catch(e) { console.error(e); }
})();
})();
